import Box from '@mui/material/Box';
import callApi from '../../utils/call_apis';
import sellerValidationSchema from '../../validations/SellerFormValidation';
import React from "react";
import Snackbar from '../generals/Snackbar';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import Link from '@mui/material/Link';
import { useSearchParams } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';


function SellerBidListingForEmpForm() {

  const [searchParams, setSearchParams] = useSearchParams()

  const initialValues = {
    // 'search_in_field': '',
    // 'search_value_in_field': '',
    'order_by': 'updated_at',
    'order_type': 'desc',
    // 'page_no': 1,
    'bid_by_emp': searchParams.get('bid_by_emp')
  }
  const [reqPayload, setReqPayload] = React.useState(initialValues);
  const [bidByEmp, setBidByEmp] = React.useState([]);
  const [bids, setBids] = React.useState([]);
  const [listingFields, setListingFields] = React.useState([]);
  const dispatch = useDispatch();

  React.useEffect(() => {
    getEmpBidListing(initialValues)
  }, []);

  const [searchBy, setSearchBy] = React.useState('product_title');

  const handleSearchByChange = (event) => {
    setSearchBy(event.target.value);
  };

  const [orderBy, setOrderBy] = React.useState('updated_at');
  // console.log('----orderBy:', orderBy);

  const handleOrderByChange = (event) => {
    setOrderBy(event.target.value);
  };

  const [orderType, setOrderType] = React.useState('desc');
  // console.log('----orderType:', orderType);

  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
  };

  // const onSubmit = values => {
  // console.log('---onSubmit--values:', values);
  //   // getEmpBidListing(values);
  // }

  const handleFilterOnSubmit = values => {
    // console.log('---handleFilterOnSubmit---')
    // console.log('---handleFilterOnSubmit---values:', values)
    if (values['search_value_in_field']) {
      values[`${searchBy}`] = values['search_value_in_field'];
    }
    if (orderType == 'desc') {
      values['order_by'] = orderBy;
      values['order_type'] = orderType;
    } else {
      values['order_by'] = orderBy;
      values['order_type'] = '';
    }
    // console.log('---order-values:', values)
    getEmpBidListing(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit: handleFilterOnSubmit,
    // validate,
    validationSchema: sellerValidationSchema.sellerBidListingSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    // authUtil.setCredentials('auth-token', response.data.data.auth_token)
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
    setBids(response.data.data.dataset)
    setBidByEmp(response.data.data.bid_by_emp_details)
    setListingFields(response.data.data.listing_fields)
    setReqPayload(response.data.data.req_payload)
  }

  const errorResponse = (error) => {
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---221:', formik.errors);
  }

  const getEmpBidListing = async (data = {}, query = {}) => {
    try {
      // callApi.requestPOST(`${apiEndpoints.apiHost}/sellers-bids/emp/create-bid`, data, {}, successResponse, errorResponse)

      const response = await callApi.requestGET(`/sellers-bids/emp/sellers-bids-listing`, data, true)
      // console.log('---getEmpBidListing---response:', response);
      successResponse(response)
    }
    catch (error) {
      // console.log('---getEmpBidListing---error:', error);
      errorResponse(error)
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid black',
    boxShadow: 24,
    p: 4,
  };

  const [sellersRespondedBidDetail, setSellersRespondedBidDetail] = React.useState([]);

  const getEmpBidListing2 = async (data = {}, query = {}) => {
    try {
      // callApi.requestPOST(`${apiEndpoints.apiHost}/sellers-bids/emp/create-bid`, data, {}, successResponse, errorResponse)

      const response = await callApi.requestGET(`/sellers-bids/emp/sellers-bids-listing`, data, true)
      // console.log('---getEmpBidListing---response:', response);
      // successResponse(response)
      setSellersRespondedBidDetail(response.data.data.dataset)
    }
    catch (error) {
      // console.log('---getEmpBidListing---error:', error);
      errorResponse(error)
    }
  }


  const [openSellerBidDetailModal, setOpenSellerBidDetailModal] = React.useState(false);
  const handleSellerBidDetailModalOpen = (bid_id, bid_by_emp_id) => {
    // console.log('---handleSellerBidDetailModalOpen--bid:', bid_id)
    getEmpBidListing2({ 'id': bid_id, 'bid_by_emp': bid_by_emp_id })
    setOpenSellerBidDetailModal(true)
  };
  const handleSellerBidDetailModalClose = () => setOpenSellerBidDetailModal(false);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));



  return (
    <div>
      <div>

        {/* <Box component="form" className="" onSubmit={formik.handleSubmit}>
          <div className='tw-grid mob:tw-grid-cols-2 desktop:tw-grid-cols-8 tw-gap-5'>

            <div className='tw-col-span-1'>
              <FormControl fullWidth>
                <InputLabel id="searchByLabel">Search By</InputLabel>
                <Select
                  labelId="searchByLabel"
                  id="searchById"
                  name="search_in_field"
                  value={searchBy}
                  label="Search By"
                  onChange={handleSearchByChange}
                  error={formik.errors.search_in_field ? true : false} 
                >
                  {listingFields.map((listingField) => (
                    <MenuItem key={listingField.key} value={listingField.key}>{listingField.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className='tw-col-span-1'>
              <TextField id="outlined-basic" label="Search" name="search_value_in_field" onChange={formik.handleChange} value={formik.values.search_value_in_field} error={formik.errors.search_value_in_field ? true : false} helperText={formik.errors.search_value_in_field} variant="outlined" />
            </div>

            <div className='tw-col-span-1'>
              <FormControl fullWidth>
                <InputLabel id="orderByLabel">Order By</InputLabel>
                <Select
                  labelId="orderByLabel"
                  id="orderById"
                  name="order_by"
                  value={orderBy}
                  label="Order By"
                  onChange={handleOrderByChange}
                  error={formik.errors.order_by ? true : false} 
                >
                  {listingFields.map((listingField) => (
                    <MenuItem key={listingField.key} value={listingField.key}>{listingField.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div className='tw-col-span-1'>
              <FormControl fullWidth>
                <InputLabel id="orderTypeLabel">Order Type</InputLabel>
                <Select
                  labelId="orderTypeLabel"
                  id="orderTypeId"
                  name="order_type"
                  value={orderType}
                  label="Order Type"
                  onChange={handleOrderTypeChange}
                  error={formik.errors.order_type ? true : false} 
                >
                  <MenuItem value={0}>Ascending</MenuItem>
                  <MenuItem value={'desc'}>Descending</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className='tw-col-span-1'>
              <TextField id="outlined-basic" label="Page No" type="number" name="page_no" onChange={formik.handleChange} value={formik.values.page_no} error={formik.errors.page_no ? true : false} helperText={formik.errors.page_no} variant="outlined" />
            </div>

            <div className='tw-col-span-1 mob:tw-col-start-2 desktop:tw-col-start-8'>
              <Button type="submit" variant="contained" >Filter</Button>
            </div>

          </div>
        </Box> */}



        <div className='tw-my-5 div-striped'>
          <h3>Bid Created By Employee</h3>
          {/* <div className="mob:tw-hidden desktop:tw-block tw-mt-5"> */}
          <div xs={12} sm={12} className='tw-w-f tw-grid desktop:tw-grid-cols-12 tw-gap-1 tw-border'>
            <span className='desktop:tw-col-span-2 tw-p-1'>Product Title</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Qty</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Base Price</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Product Expiry</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Bid Valid Till</span>
            <span className='desktop:tw-col-span-2 tw-p-1'>Bid by other Seller</span>
            <span className='desktop:tw-col-span-2 tw-p-1'>Bid Requested by</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Created at</span>
            {/* <span className='desktop:tw-col-span-1 tw-p-1'>Updated at</span> */}
            <span className='desktop:tw-col-span-1 tw-p-1'>Action</span>
          </div>
          {/* </div> */}

          {bidByEmp.map((bid) => (
            // <li key={bid.id}>
            // <div className="tw-mt-2">
            <div key={bid.id} xs={12} sm={12} className='tw-w-f mob:tw-text-[12px] tw-grid mob:tw-grid-cols-6 desktop:tw-grid-cols-12 tw-gap-1 tw-border'>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-2 tw-p-1 mob:tw-text-[14px]'>{bid.product_title}</span>
              <span className='mob:tw-col-span-1 desktop:tw-col-span-1 tw-p-1'><span className='mob:tw-block desktop:tw-hidden'>Qty: </span>{bid.quantity}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1'><span className='mob:tw-block desktop:tw-hidden'>Max Bid Price: </span>{bid.max_bid_price}</span>
              <span className='mob:tw-col-span-1 desktop:tw-col-span-1 tw-p-1'><span className='mob:tw-block desktop:tw-hidden'>Product Expiry: </span>{bid.product_expiry_type_name}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1'><span className='mob:tw-block desktop:tw-hidden'>Bid Valid Till: </span>{bid.bid_valid_till}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-2 tw-p-1'> {bid.bid_by_other_seller} Bid by other Seller</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-2 tw-p-1 tw-break-all'> {bid.requested_by}</span>
              <span className='mob:tw-col-span-6 desktop:tw-col-span-1 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Created at:&nbsp;</span>{bid.created_at}</span>
              {/* <span className='mob:tw-col-span-6 desktop:tw-col-span-1 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Updated at:&nbsp;</span>{bid.updated_at}</span> */}
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1'><Link href={`/emp/create-bid?bid_by_emp_id=${bid.id}&form_action=update`} target='_blank'>Edit</Link></span>
            </div>
            // </div>
            // </li>
          ))}

        </div>


        <div className='tw-my-5 div-striped'>
          <h3>Sellers Repsonded Bid</h3>

          {/* <div className="mob:tw-hidden desktop:tw-block tw-mt-5"> */}
          <div xs={12} sm={12} className='tw-w-f tw-grid desktop:tw-grid-cols-12 tw-gap-1 tw-border'>
            <span className='desktop:tw-col-span-3 tw-p-1'>Product Title</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Qty</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Bid Price</span>
            {/* <span className='desktop:tw-col-span-1 tw-p-1'>Product Expiry</span> */}
            {/* <span className='desktop:tw-col-span-1 tw-p-1'>Price with GST</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Price without GST</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Discount on MRP</span>
            <span className='desktop:tw-col-span-1 tw-p-1'>Discount on PTR</span> */}
            <span className='desktop:tw-col-span-2 tw-p-1'>Responded By</span>
            <span className='desktop:tw-col-span-2 tw-p-1'>Mobile Number</span>
            <span className='desktop:tw-col-span-2 tw-p-1'>Created at</span>
            {/* <span className='desktop:tw-col-span-1 tw-p-1'>Updated at</span> */}
            <span className='desktop:tw-col-span-1 tw-p-1'>Action</span>
          </div>
          {/* </div> */}

          {bids.map((bid) => (
            // <li key={bid.id}>
            // <div className="tw-mt-2">
            <div key={bid.id} xs={12} sm={12} className='tw-w-f mob:tw-text-[12px] tw-grid mob:tw-grid-cols-6 desktop:tw-grid-cols-12 tw-gap-1 tw-border'>
              <span className='mob:tw-col-span-3 mob:tw-row-span-2 desktop:tw-col-span-3 tw-p-1 mob:tw-text-[14px]'>{bid.product_title}</span>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-1 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Quantity:&nbsp;</span>{bid.quantity}</span>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-1 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Bid Price:&nbsp;</span>{bid.bid_price}</span>
              {/* <span className='mob:tw-col-span-3 desktop:tw-col-span-1 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden tw-w-auto'>Product Expiry:&nbsp;</span>{bid.product_expiry}</span> */}
              {/* <span className='mob:tw-col-span-3 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Price with GST:&nbsp;</span>{bid.price_with_gst || 'NA'}</span>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Price without GST:&nbsp;</span>{bid.price_without_gst || 'NA'}</span>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Discount on MRP:&nbsp;</span>{bid.discount_on_mrp || 'NA'}</span>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Discount on PTR:&nbsp;</span>{bid.discount_on_ptr || 'NA'}</span> */}
              <span className='mob:tw-col-span-6 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Responded by:&nbsp;</span>{bid.responded_by_name}</span>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Mobile Number:&nbsp;</span>{bid.responded_by_mob_number}</span>
              <span className='mob:tw-col-span-6 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Created at:&nbsp;</span>{bid.created_at}</span>
              {/* <span className='mob:tw-col-span-6 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Updated at:&nbsp;</span>{bid.updated_at} <Link onClick={() => handleSellerBidDetailModalOpen(bid.id, bid.bid_by_emp)}>link</Link> </span> */}
              <span className='mob:tw-col-span-6 desktop:tw-col-span-1 tw-p-1 tw-flex'> <Link onClick={() => handleSellerBidDetailModalOpen(bid.id, bid.bid_by_emp)}>more info</Link> </span>
            </div>
            // </div>
            // </li>
          ))}

        </div>

      </div>

      <Modal
        open={openSellerBidDetailModal}
        onClose={handleSellerBidDetailModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Sellers Bid Details
          </Typography>
          <Typography id="modal-modal-description">
          </Typography>

          {/* <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableBody> */}
          {/* <div className=''> */}
          {sellersRespondedBidDetail.map((row) => (
            // <li key={bid.id}>
            // <div className="tw-mt-2">

            <div key={row.id} className='div-striped'>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Product Title:</span> {row.product_title}</div>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Quantity:</span> {row.quantity}</div>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Price/Discount:</span> {row.bid_price}</div>
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Comment:</span> {row.comment}</div>
              {/* <div className='tw-flex tw-p-5'><span className='tw-w-40'>Product Expiry:</span> {row.product_expiry}</div> */}
              <div className='tw-flex tw-p-5'><span className='tw-w-40'>Created at:</span> {row.created_at}</div>
            </div>

            // </div>
            // </li>
          ))}
          {/* </div> */}
          {/* </TableBody>
          </Table>
          </TableContainer> */}

        </Box>
      </Modal>

      <Snackbar />
    </div>
  );

}


export { SellerBidListingForEmpForm };
